<template>
    <div class="col-12 my-4">
        <div class="card p-0">
            <div class="card-header">
                <b>Filter results</b>
            </div>
            <div class="card-body row">
                <div class="col-6 col-sm-3 col-sm-2 mb-2 mb-sm-0" v-for="(option, key) in formattedOptions" :key="key">
                    <Field v-slot="{ value }" :name="option.name" as="select" class="form-select size-input" @change="this.$parent.filterTyres()" v-model="this.$parent.selectedSizes[option.name]">
                        <option value="">{{ option.label }}</option>
                        <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                    </Field>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Field } from 'vee-validate';

    export default {
        props: ['formattedOptions', 'brandId', 'rangeId', 'homeDeliverySet'],
        components: { Field }
    }
</script>

<style lang="scss" scoped>
</style>